import getPermissions from "./utils/getPermissions";
import omitEmpty from "./utils/omitEmpty";
export default {
    get: function (token) {
        var fidel = getPermissions(token, "deals", ["deals"], ["read"], "canViewCardlink") &&
            getPermissions(token, "fidel", ["cards"], ["read", "create"]);
        /** @description: Hide Perks GO / location lanes as corona-virus 27/3/2020 */
        // const geoLocation = getPermissions(token, "deals", ["locations"], ["read"])
        // @todo change to correct companyValues permissions in future
        var companyValues = getPermissions(token, "recognition", ["recognition"], ["create", "read"]);
        var cultureHub = getPermissions(token, "culture-hub", ["culture-hub"], ["read"]);
        var permissions = {
            companyValues: companyValues,
            fidel: fidel,
            geoLocation: false,
            cultureHub: cultureHub
        };
        return omitEmpty(permissions);
    }
};
